import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { format, parseISO } from 'date-fns';
import Typography from '@styles/typography.module.less';
import s from './ContentShootDetails.module.less';

type Props = {
  requesterName: string;
  requesterEmail: string;
  requestedAt: string;
};

const Header = ({ requesterName, requesterEmail, requestedAt }: Props) => {
  const { t } = useTranslation('admin');

  return (
    <>
      <div className={classnames(Typography.headerMediumSemibold, s.contentShootDetailsTitle)}>
        {t('media.contentShootDetails.title')}
      </div>
      <div className={s.requester}>
        {t('media.contentShootDetails.requester', {
          name: requesterName,
          email: requesterEmail,
          date: format(parseISO(requestedAt), 'PP'),
          time: format(parseISO(requestedAt), 'p'),
        })}
      </div>
    </>
  );
};

export default Header;
